import { render, staticRenderFns } from "./QuestionnaireAdmin.vue?vue&type=template&id=dd4f86f4&"
import script from "./QuestionnaireAdmin.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports